<template>
  <div class="content">
    <div class="header">
      <div class="menus">
        <div class="shop_name">{{ language['欢迎进入'][LT] }}-{{ shopDetail.dining_name }}{{ language['店铺'][LT] }}</div>
        <div class="menu">
          <el-menu :router="true" text-color="#333" active-text-color="#333" background-color="rgb(139, 188, 247)"
            class="el-menu-demo" mode="horizontal" >
            <el-menu-item index="1" route="/"> {{ language['桌台管理'][LT] }}</el-menu-item>
            <el-menu-item index="2" route="/orderList"> {{ language['订单管理'][LT] }}</el-menu-item>
            <el-menu-item index="3" route="/dishList"> {{ language['菜品管理'][LT] }}</el-menu-item>
            <el-submenu index="4">
              <template slot="title"> {{ language['账单管理'][LT] }}</template>
              <el-menu-item index="4-1" route="/bill"> {{ language['日账单'][LT] }}</el-menu-item>
              <el-menu-item index="4-2" route="/billMonth"> {{ language['月账单'][LT] }}</el-menu-item>
            </el-submenu>
            <!-- <el-menu-item index="5" route="/memberList"> {{ language['会员管理'][LT] }}</el-menu-item> -->
            <el-menu-item index="6" route="/repertoryList"> {{ language['商品库存'][LT] }}</el-menu-item>
          </el-menu>
        </div>
      </div>
      <!-- <div style="color: #fff;" @click="cutText()">{{LT == 'zh' ?'中':'英'}}</div> -->
      <div class="user">
        <img class="head_img" :src="shopDetail.logo_image" alt="">
        <span>{{ userInfo.user_nickname }}</span>
        <img @click="getLogOut" class="log_out" src="@/assets/img/5.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import language from '../../static/i18n/zh';

export default {
  name: 'HelloWorld',
  data() {
    return {
      shopDetail: {},
      userInfo: {}
    }
  },
  mounted() {
    this.getShopDetail();
    if (JSON.parse(localStorage.getItem('TOKEN'))) {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    }
    console.log(this.userInfo, 111111111);
    this.$EventBus.$on("login", () => {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    });
  },
  methods: {
    cutText(){
      this.$method()
      this.$router.push()

    },
    // 店铺详情
    getShopDetail() {
      this.$post('64c3154dd8286').then(res => {
        if (res.code == 1) {
          console.log('店铺详情', res)
          this.shopDetail = res.data;
        }
      })
    },
    // 退出登录
    getLogOut() {
      this.$confirm(this.language['确定退出登录吗？'][this.LT], this.language['提示'][this.LT], {
        confirmButtonText: this.language['确定'][this.LT],
        cancelButtonText: this.language['取消'][this.LT],
      }).then(() => {
        localStorage.removeItem('userInfo');
        localStorage.removeItem('TOKEN');
        this.$router.push({ path: '/login' });
      }).catch(() => {

      });

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgb(139, 188, 247);
  padding: 0 30px;
}

.el-menu {
  background: rgb(139, 188, 247);
}

.menus {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 80%;
}

.el-menu-item:hover {
  background: #fff !important;
}

.el-submenu:hover {
  background: #fff !important;
}

.el-menu-item.is-active {
  color: #333 !important;
  font-weight: bold;
}

.shop_name {
  font-size: 16px;
  color: #fff;
  margin-right: 30px;
}

.user {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.user span {
  font-size: 14px;
  margin-left: 5px;
  color: #fff;
}

.head_img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.log_out {
  width: 20px;
  height: 20px;
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue